import { render, staticRenderFns } from "./shangbaosearch.vue?vue&type=template&id=0b61a03c&scoped=true&"
import script from "./shangbaosearch.vue?vue&type=script&lang=js&"
export * from "./shangbaosearch.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=0b61a03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61a03c",
  null
  
)

export default component.exports